import React from 'react';
import { wrapDisplayName, setDisplayName } from 'recompose';

const JW_API = process.env.REACT_APP_JW_API;
// const DEFAULT_CHAPTER_SLUG = process.env.REACT_APP_DEFAULT_CHAPTER_SLUG;

const { Provider, Consumer } = React.createContext({});

/**
 * Development helper.
 * At mount, retrieves chapter data from the server and passes it down using
 * the `children as a render prop` pattern.
 */
export class EpisodeProvider extends React.Component {
  static defaultProps = {
    fullData: null,
    slug: null,
  };

  state = {
    chapter: null,
    isLoading: true,
  };

  componentDidMount() {
    if (this.props.fullData) {
      this.useFullData();
    } else {
      this.getData();
    }
  }

  useFullData() {
    this.setState({
      episode: this.props.fullData,
      isLoading: false,
    });
  }

  getData = async () => {
    const { slug } = this.props;

    // const chapterSlug = window.location.pathname
    //   .replace(`/${BASE_PATH}/`, '')
    //   .replace(/^\//, '');

    // if (!chapterSlug) {
    //   // if there's no chapterSlug in the url,
    //   if (DEFAULT_CHAPTER_SLUG) {
    //     // we do a redirect to the default chapterSlug
    //     const redirectURLPrefix = BASE_PATH ? `/${BASE_PATH}/` : '';
    //     const redirectURL = redirectURLPrefix + DEFAULT_CHAPTER_SLUG;
    //     window.location.href = redirectURL;
    //   }
    //   if (process.env.NODE_ENV !== 'production') {
    //     const chapter = testEpisode.result;
    //     this.setState({ chapter, isLoading: false });
    //     return;
    //   }
    // }

    const url = `${JW_API}episodes/${slug}`;

    try {
      this.setState({ isLoading: true });
      const response = await fetch(url);
      const json = await response.json();
      const validState = response.status >= 200 && response.status < 300;
      if (!validState) {
        if (json.error) {
          throw new Error(json.error);
        } else {
          throw new Error(`Server responded with status:${response.status}`);
        }
      }
      this.setState({ episode: json.result, isLoading: false });
    } catch (ex) {
      console.error(ex);
      this.setState({ isLoading: false });
    }
  };

  render() {
    const { episode, isLoading } = this.state;
    return (
      <Provider value={{ episode, isLoading }} children={this.props.children} />
    );
  }
}

/**
 * Higher Order Component (HOC) that make it possible for components
 * to consume preferences
 */
export const withEpisode = BaseComponent => {
  const Wrapped = props => (
    <Consumer>
      {context => (
        <BaseComponent
          {...props}
          episode={context.episode}
          isEpisodeLoading={context.isLoading}
        />
      )}
    </Consumer>
  );

  return setDisplayName(wrapDisplayName(BaseComponent, 'withUIState'))(Wrapped);
};
